import React from 'react'

export const GeolocationApiContext = React.createContext({ apiContext: null })
